import React from 'react';
import { FormPage, FormPageProps } from '../Page/FormPage';
import { SettingsPageHeaderTitle } from './SettingsPageHeaderTitle';

export const SettingsPageForm: React.FC<FormPageProps> = props => (
  <FormPage
    title={<SettingsPageHeaderTitle />}
    actionLabel="Update"
    isSettingsForm
    showConfirmationModal
    headerVariant="bottomBorder"
    xs={12}
    {...props}
  />
);
